import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { useTheme } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import OmniToolbar from "./omniToolbar";
import PortalAvatar from "./portalAvatar";
import { getCurrentPortalSection } from "./portalSections";

const PortalAppBar = props => {
  const {
    title = "Welcome",
    belowTitle = "Welcome",
    hideMenu = true,
    botpressStyle = false,
    hideAvatar = false,
  } = props;

  const theme = useTheme();

  const currentDepth = window.location.pathname.split("/").length;

  const smallScreen = useMediaQuery(theme => theme.breakpoints.down("sm"));

  // Current portal section (icon + name) derived from the URL — display only.
  const currentSection = getCurrentPortalSection(window.location.pathname);
  const SectionIcon = currentSection.Icon;

  if (botpressStyle) {
    return (
      <AppBar
        sx={{
          boxShadow: "none",
          borderBottom: `1px solid ${theme.palette.primary.light}`,
          paddingLeft: theme.spacing(1),
          zIndex: "998",
        }}
      >
        <OmniToolbar disableGutters={true}>
          <Box
            sx={[
              {
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
              },
              currentDepth > 2 && {
                marginLeft: `-${theme.spacing(1)}`,
              },
            ]}
          >
            <Typography
              variant="overline"
              noWrap
              component="div"
              sx={{ marginLeft: theme.spacing(1), lineHeight: 1.4 }}
            >
              {props.organizationODM ? props.organizationODM.omniData.name : "Quick Navigation"}
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginLeft: theme.spacing(1),
              }}
            >
              <SectionIcon
                fontSize={smallScreen ? "small" : "medium"}
                sx={{ marginRight: theme.spacing(0.75) }}
              />
              <Typography
                variant={smallScreen ? "h6" : "h5"}
                noWrap
                component="div"
                sx={{ fontWeight: 600 }}
              >
                {currentSection.label}
              </Typography>
            </Box>
            {/* Section navigation and account/options now live in the clipped
                mini-variant PortalNavDrawer (left), so there is no top-right menu here. */}
          </Box>
        </OmniToolbar>
      </AppBar>
    );
  } else {
    return (
      <AppBar
        sx={{
          boxShadow: "none",
          borderBottom: `1px solid ${theme.palette.primary.light}`,
          paddingLeft: theme.spacing(1),
          zIndex: "998",
        }}
      >
        <OmniToolbar disableGutters={true}>
          <Box
            sx={[
              {
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
              },
              currentDepth > 2 && {
                marginLeft: `-${theme.spacing(1)}`,
              },
            ]}
          >
            <Typography
              variant="overline"
              noWrap
              component="div"
              sx={[hideMenu && { marginLeft: theme.spacing(1), marginBottom: 0 }, { flexGrow: 1 }]}
            >
              {title}
            </Typography>
            <Typography
              variant="h5"
              noWrap
              component="div"
              sx={[
                hideMenu && { marginLeft: theme.spacing(1), marginTop: `-${theme.spacing(1)}` },
                { flexGrow: 1 },
              ]}
            >
              {props.organizationODM ? props.organizationODM.omniData.name : belowTitle}
            </Typography>
          </Box>
          <Box sx={{ flexGrow: 0 }}>{!hideAvatar && <PortalAvatar />}</Box>
        </OmniToolbar>
      </AppBar>
    );
  }
};

const mapStateToProps = state => ({
  bpShowChat: state.userSession.bpShowChat,
  organizationODM: state.userSession.organizationODM,

  awsGroup: state.userSession.awsGroup,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PortalAppBar));
